import { useState, useEffect } from 'react';
import { SelectOptionReport } from './helper.Print.Const';
import CircularWait from 'components/Fragments/CircularWait';

// Imprime (função assíncrona)
async function Print({ paramns, onPdfGenerated }) {
  let id = paramns.id;
  let filter = paramns.filter || null;

  if (Array.isArray(paramns)) {
    id = paramns[0].id;
    filter = paramns.map(f => f.filter).join('&');
  }
  let opt = SelectOptionReport(id);
  console.log("ID do relatório:", id); // Log do ID do relatório

  const apiUrl = process.env.REACT_APP_REPORT_API_URL;
  const _apiUrl = `${apiUrl}print/${opt.group}/${opt.name}?filter=${filter}`;
  console.log("URL do PDF:", _apiUrl); // Log da URL do PDF
  try {
    const response = await fetch(_apiUrl, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    if (response.ok) {
      const blob = await response.blob();
      const pdfBlobUrl = URL.createObjectURL(blob);

      if (onPdfGenerated) {
        onPdfGenerated(pdfBlobUrl);
      }

      return pdfBlobUrl; // Retorna a URL do blob
    } else if (response.status === 400) {
      const errorData = await response.json();
      const errorMessage = errorData?.message || 'Requisição inválida';
      throw new Error(errorMessage);
    } else {
      throw new Error('Ocorreu um erro ao buscar o relatório.');
    }
  } catch (error) {
    console.error("Erro ao gerar PDF:", error);
    // Lida com o erro de forma apropriada (ex: exibe mensagem para o usuário)
    throw error; // Permite que o erro seja propagado para o chamador
  }
}

// Visualiza
function PrintPreview({ paramns }) {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Estado para controlar o carregamento
  const [error, setError] = useState(null);         // Estado para armazenar mensagem de erro

  useEffect(() => {



    const gerarPdf = async () => {
      try {
        const resultadoPrint = 
          await Print({paramns ,onPdfGenerated: (generatedUrl) =>  {setPdfUrl(generatedUrl);}
        });
      } catch (error) {
        setError(error.message); // Define a mensagem de erro no estado
      } finally {
        setIsLoading(false); // Termina o carregamento, independentemente de sucesso ou erro
      }
    };

    gerarPdf();
  }, [paramns]);

  return (
    <main id="PrintPage" className="main-page" style={{ width: '100%', height: '800px', overflow: 'hidden' }}>
      {isLoading ? (
          <CircularWait size="grande" /> 
      ) : error ? (
        <p>Erro ao gerar PDF: {error}</p> // Mensagem de erro
      ) : (
        <>
          <h4>Relatório:</h4>
          <iframe src={pdfUrl} style={{ width: '100%', height: '100%' }} />
        </>
      )}
    </main>
  );
}

export { Print, PrintPreview  };
